/* global OffAmazonPayments, MR */
<!--
  AmazonPayButton component goes along with AmazonPayWidget. They can be positioned independently
  and they depend on $store value 'payments.validAmazonSession'
-->
<template lang="pug">
  #AmazonPayButton(rel="amazonBtn")

</template>

<script>
  export default {
    name: "AmazonPayButton",

    data() {
      return {
        redirectUrl: null
      }
    },

    props: {
      event: {
        type: String,
        required: false,
        default: null
      },

      login: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    mounted() {
      //- redirectUrl will be used by Amazon, after user logs in, to reroute them back where they started
      this.redirectUrl = `${this.$route.path}?editPayment=amazon`;
      this.initButton();
    },

    methods: {
      initButton(event, redirectUrl, login) {
        const self = this;

        if (OffAmazonPayments) {
          OffAmazonPayments.Button('AmazonPayButton', MR.config.amazonSellerId, {
            type: "PwA",
            color: "LightGray",
            size: "large",
            authorization: function() {
              var loginOptions = {
                scope: 'profile postal_code payments:widget payments:shipping_address payments:autopay_consent',
                popup: false
              };

              if (event) {
                self.trackEvent(event, null);
              }

              document.cookie = `amazon_redirect=${self.redirectUrl};`;
              self.trackEvent('Payment Selected', { type: 'Amazon' });

              if (login) {
                redirectUrl = '/amazonLogin';
              }

              amazon.Login.authorize(loginOptions, self.redirectUrl);
            }
          });
        }
      }
    }
  }
</script>

<style scoped lang="stylus">

</style>